import checkStatus from '../utils/checkStatus';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import api from '../utils/api';
import JwtStore from './JwtStore';
import dispatchHttpError from '../utils/dispatchHttpError';

export default {
  fetch() {
    return fetch(api('product-focuses'), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      }
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.PRODUCT_FOCUSES_FETCH_COMPLETED,
        productFocuses: response.data,
      }))
      .catch(dispatchHttpError);
  },
  fetchById(id) {
    return fetch(api(`product-focuses/${id}`), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.PRODUCT_FOCUS_FETCH_BY_ID_COMPLETED,
        productFocus: response.data,
      }))
      .catch(dispatchHttpError);
  },
  saveActivity(activity){
    return fetch(api('product-focus-activities'), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(activity),
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.PRODUCT_FOCUS_VIEWED_COMPLETED,
        productFocus: response.data,
      }))
      .catch(dispatchHttpError);
  }
}
